import React, { ReactElement, useState } from 'react';
import {
  Breadcrumbs,
  HiddenPriorityTitle,
  homeBreadcrumb,
  Message,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import routes from '../../routing/routes';
import Layout from '../Layout';
import { useClient } from '../../context/ClientStatusContext';
import NajcastejsieOtazky from '../../module/NajcastejsieOtazky/NajcastejsieOtazky';
import { getNajcastejsieOtazky } from '../../client/najcastejsieOtazkyClient';

const NajcastejsieOtazkyPage = (): ReactElement => {
  const {
    data,
    status,
  } = useClient(
    () => getNajcastejsieOtazky(),
  );
  const [displayError, setDisplayError] = useState(true);

  return (
    <Layout>
      <HiddenPriorityTitle>Najčastejšie otázky</HiddenPriorityTitle>
      <Breadcrumbs
        routeList={[
          homeBreadcrumb(process.env.REACT_APP_STATICKY_OBSAH_URL as string),
          {
            to: routes.najcastejsieOtazky.to,
            heading: routes.najcastejsieOtazky.name,
          },
        ]}
      />
      <Loader loading={status.loading}>
        {(status.responseCode && status.responseCode > 399) ? (
          <>
            {displayError && (
              <Message
                type="error"
                onClear={() => setDisplayError(false)}
                headingSize="m"
              >
                Nepodarilo sa načítať najčastejšie otázky.
              </Message>
            )}
          </>
        )
          : (
            <NajcastejsieOtazky
              data={data}
            />
          )}
      </Loader>
    </Layout>
  );
};

export default NajcastejsieOtazkyPage;
